import styled, { css } from 'styled-components'

import FormLabel from '../../FormLabel'
import FormFieldCheckbox from '../FormFieldCheckbox'

export const Wrapper = styled.div<{ $isDisabled?: boolean }>`
  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      opacity: 0.4;
      cursor: not-allowed;
    `}
`

export const Label = styled(FormLabel)``

export const Options = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`

export const Text = styled.p`
  ${({ theme }) => theme.textStyles.firaSansTextBase};
  color: ${({ theme }) => theme.colors.blueSecondaryBis};
  margin-bottom: 1.2rem;
`

export const Checkbox = styled(FormFieldCheckbox)`
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`

const HintMessage = styled.p`
  ${({ theme }) => theme.textStyles.firaSansTextBase}
  margin-top: 0.5rem;
  padding-inline: 0.8rem;
  text-align: left;
`
export const Help = styled(HintMessage)`
  color: ${({ theme }) => theme.colors.bismark};
`
export const Error = styled(HintMessage)`
  color: ${({ theme }) => theme.colors.error};
`
